<template>
  <div>
    <div v-if="!loading && rules && rules.length" class="d-flex flex-wrap">
      <rule-card
        v-for="rule in rules"
        :rule="rule"
        class="mb-3 mr-3"
        :key="rule.id"
        @deleted="refreshRules"
        @edit-rule="openEdit(rule)"
      />
    </div>
    <div v-else-if="!loading">No alert rules — would you like to <router-link :to="{ name: 'Create Rule' }">create one</router-link>?</div>

    <EditRule
      v-if="selectedRule"
      :rule="selectedRule"
      :show="showEditModal"
      @saved="refreshRules"
      @close="closeEdit"
    />
  </div>
</template>

<script>
import { DEVICES_QUERY, RULES_QUERY } from '@/constants/graphql'
import RuleCard from '@/components/rules/RuleCard.vue'
import EditRule from '@/components/rules/EditRule.vue'

export default {
  name: 'rules',
  components: { RuleCard, EditRule },
  data () {
    return {
      selectedRule: null,
      showEditModal: false,
      error: false,
      loading: 0
    }
  },
  methods: {
    openEdit (rule) {
      this.selectedRule = { ...rule }
      this.showEditModal = true
    },
    closeEdit () {
      this.showEditModal = false
      this.selectedRule = null
    },
    refreshRules () {
      this.closeEdit()
      this.$apollo.queries.rules.refetch()
    }
  },
  mounted () {
    this.$apollo.queries.rules.refetch()
  },
  apollo: {
    devices: {
      query: DEVICES_QUERY
    },
    rules: {
      query: RULES_QUERY,
      error () {
        this.error = true
      }
    }
  }
}
</script>
